<div class="filter-statements-container">
  <div class="modal_header">
    <i class="fa fa-filter header-icon"></i>
    <p class="header-text">{{ HEADER_TEXT }}</p>
    <p class="header-description">Select statements to hide/show in the financial summary. The available statements will update as you select different filters.</p>
  </div>

  <div class="modal__content">

    <div class="reporting-interval-and-year">
      <div class="reporting-interval-dropdown">
        <p class="dropdown-label">Reporting Interval</p>
        <app-popover-menu-multi-select
          [multiSelectOptions]="multiSelectOptionsForReportingInterval"
          [buttonText]="multiSelectButtonTextForReportingInterval"
          (selectOrDeselectAll)="handleSelectOrDeselectAll(multiSelectOptionsForReportingInterval)"
        ></app-popover-menu-multi-select>
      </div>

      <div class="year-dropdown">
        <p class="dropdown-label">Years</p>
        <app-popover-menu-multi-select
          [multiSelectOptions]="multiSelectOptionsForYears"
          [buttonText]="multiSelectButtonTextForYears"
          (selectOrDeselectAll)="handleSelectOrDeselectAll(multiSelectOptionsForYears)"
        ></app-popover-menu-multi-select>
      </div>

      <div class="scenarios-dropdown">
        <p class="dropdown-label">Scenario</p>
        <app-popover-menu-multi-select
          [multiSelectOptions]="multiSelectOptionsForScenario"
          [buttonText]="multiSelectButtonTextForScenarios"
          (selectOrDeselectAll)="handleSelectOrDeselectAll(multiSelectOptionsForScenario)"
        ></app-popover-menu-multi-select>
      </div>

      <div class="months-covered-dropdown">
        <p class="dropdown-label">Months Covered</p>
        <app-popover-menu-multi-select
          [multiSelectOptions]="multiSelectOptionsForMonthsCovered"
          [buttonText]="multiSelectButtonTextForMonthsCovered"
          (selectOrDeselectAll)="handleSelectOrDeselectAll(multiSelectOptionsForMonthsCovered)"
        ></app-popover-menu-multi-select>
      </div>
    </div>

    <div class="available-statements-dropdown-header">
      <p class="dropdown-label">Available Statements</p>
      <p class="numberOfAvailableStatementsSelected">{{ numberOfAvailableStatementsSelectedText }}</p>
    </div>
    @if (showFilterMismatchBanner) {
      <div class="filter-mismatch-banner">
        <i class="fa fa-triangle-exclamation"></i>
        <span>{{ filterMismatchBannerText }} <button type="button" class="btn btn-link clear-filters-inline-btn" (click)="resetFilters()">Clear filters</button></span>
      </div>
    }
    <div class="available-statements-dropdown-inner-container">
      <ul (click)="$event.stopPropagation()">
        <li [class.disabled]="allAvailableOptions.length === 0" class="popover-menu-item">
          <div class="checkbox-label-container">
            <input class="multi-select-checkbox" type="checkbox"
              id="{{'selectDeselectAllCheckbox'}}"
              (click)="handleSelectOrDeselectAll(multiSelectOptionsForAvailableStatements)"
              [checked]=areAllPeriodsChecked()>
            <label class="item-title select-deselect-title"
            for="{{'selectDeselectAllCheckbox'}}">{{ selectAllMatchingLabel }}</label>
          </div>
        </li>
        @if (multiSelectOptionsForAvailableStatements.length == 0) {
          <div class="no-statements-label">
            No statements found
          </div>
        }
        @for (option of multiSelectOptionsForAvailableStatements; track option; let idx = $index) {
          @if (option.hide !== true && multiSelectOptionsForAvailableStatements.length > 0) {
            <li
              class="popover-menu-item">
              <div class="checkbox-label-container">
                <input class="multi-select-checkbox" type="checkbox"
                  id="{{'multiSelectCheckbox' + idx}}" (click)="option?.action()"
                  [checked]="option.checked">
                <div class="flexbox-title-subtitle">
                  <div>
                    <label class="item-title"
                    for="{{'multiSelectCheckbox' + idx}}">{{ option.title }}</label>
                    @if (option.willBeLoaded && option.checked) {
                      <span class="statement-will-be-loaded-tag">will be loaded</span>
                    }
                  </div>
                  <div class="subtitle-container">
                    <label class="item-subtitle"
                    for="{{'multiSelectCheckbox' + idx}}">{{ option.subtitle1 }}</label>
                    <div class="separator-container">
                      <svg class="circle-seperator" width="7" height="4" viewBox="0 0 4 4"
                        xmlns="http://www.w3.org/2000/svg" style="display: inline-block;">
                        <rect id="Rectangle-Copy-12" fill="#CCCCCC" fill-rule="nonzero" x="0" y="0"
                        width="4" height="4" rx="2"></rect>
                      </svg>
                    </div>
                    <label class="item-subtitle"
                    for="{{'multiSelectCheckbox' + idx}}">{{ option.subtitle2 }}</label>
                    <div class="separator-container">
                      <svg class="circle-seperator" width="7" height="4" viewBox="0 0 4 4"
                        xmlns="http://www.w3.org/2000/svg" style="display: inline-block;">
                        <rect id="Rectangle-Copy-12" fill="#CCCCCC" fill-rule="nonzero" x="0" y="0"
                        width="4" height="4" rx="2"></rect>
                      </svg>
                    </div>
                    <label class="item-subtitle"
                    for="{{'multiSelectCheckbox' + idx}}">{{ option.subtitle3 }}</label>
                  </div>
                </div>
              </div>
            </li>
          }
        }
      </ul>
    </div>
  </div>
  <div class="d-flex justify-content-between align-items-center footer">
    <button type="reset" class="btn btn-link clear-filters-btn" (click)="resetFilters();" [disabled]="!hasFiltersApplied">
      <i class="fa fa-times"></i> Clear Filters
    </button>
    <div class="footer-right-buttons">
      <button type="button" class="btn btn-link" (click)="close(true);">Cancel</button>
      <button type="submit" class="btn btn-primary" (click)="filterStatements();">
        <span class="apply-filter-btn-label">Apply Filter</span>
        @if (isFiltering) {
          <div class="loader button-loader apply-filter-btn-icon"></div>
        }
      </button>
    </div>
  </div>
</div>